import React from 'react';
import PropTypes from 'prop-types';

import InternalBrokers from 'bundles/apex/deals/form/fields/internal_brokers';
import OutsideBrokers from 'bundles/apex/deals/form/fields/outside_brokers';
import TransactionSide from 'bundles/apex/deals/form/fields/transaction_side_totals';
import { getTransactionSideLabel } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';
import { getTransactionSideOptionLabels } from 'bundles/apex/deals/helpers/labels';

export default function TransactionSideSubsection({ deal, transactionSide }) {
  if (!deal.dealType || !deal.stage) {
    return null;
  }

  const transactionSideOptions = getTransactionSideOptionLabels(deal.dealType);
  const label = getTransactionSideLabel(transactionSide, transactionSideOptions);

  return <>
    <h4>{label}</h4>
    <section className="mb-4">
      <TransactionSide className="mb-4" deal={deal} transactionSide={transactionSide} />

      <h5>Outside Brokers</h5>
      <OutsideBrokers transactionSide={transactionSide} />

      <h5>Internal Brokers</h5>
      <InternalBrokers transactionSide={transactionSide} />
    </section>
  </>;
}

TransactionSideSubsection.propTypes = {
  deal: PropTypes.shape({
    transactionSideDetails: PropTypes.arrayOf(PropTypes.shape({
      grossAmount: PropTypes.number.isRequired,
      grossPercent: PropTypes.number.isRequired,
      transactionSide: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  transactionSide: PropTypes.string.isRequired,
};
